import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';

export const currentLocation = window.location.origin;

const API_URLS = {
	'https://testapp.enter.izvrsna.hr': 'https://testapi.enter.izvrsna.hr/api',
	'https://app.enter.fit': 'https://api.enter.fit/api',
	'default': 'http://local.e-udruge-backend.com/api',
};

const SITE_KEYS = {
	'https://testapp.enter.izvrsna.hr': {
		SITE_KEY: '6LdypOwqAAAAAM8bvoBlP3MdAJjm1u8Ees7chUCk',
		SECRET_KEY: '6LdypOwqAAAAAPFEg-rAW3Czofb8sMUGtWA18Ghf'
	},
	'https://app.enter.fit': {
		SITE_KEY: '6Lcd4gsrAAAAAH5sQlvojFnoZCOtfdQthbcaz2Ji',
		SECRET_KEY: '6Lcd4gsrAAAAABGd-cI819-cRpzoF7Sd46YlEZFA'
	},
	'default': {
		SITE_KEY: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
		SECRET_KEY: '6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe'
	}
};


export const APP_NAME = 'Enter';
export const DateFormat = 'DD.MM.YYYY.';
export const DefaultNumberItemPerPage = 20;
export const DateFormatWithTime = 'DD.MM.YYYY. HH:mm';
export const FormatTime = 'HH:mm';

export const API_BASE_URL = API_URLS[currentLocation] || API_URLS['default'];
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const UNAUTHENTICATED_ENTRY = '/login'
export const REACT_APP_GOOGLE_MAPS_API_KEY="AIzaSyBroEjodAVI0htzJry76vzS5HxuWetTSWw"

const siteConfig = SITE_KEYS[currentLocation] || SITE_KEYS['default'];
export const REACT_APP_SITE_KEY = siteConfig.SITE_KEY;
export const REACT_APP_SECRET_KEY = siteConfig.SECRET_KEY;

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'hr',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#224368',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};
